import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import MaintenancePage from "./components/MaintenancePage";
import CourseList from "./components/CourseList";
import CoursePage from "./components/CoursePage";
import PrivacyPolicy from "./components/PrivacyPolicy";
import SiteGuidelines from "./components/SiteGuidelines";
import HomePage from "./components/HomePage";
import CourseListUTSG from "./components/CourseListUTSG";
import CourseListUTM from "./components/CourseListUTM";
import AboutUs from "./components/AboutUs";
import MeetTheTeam from "./components/MeetTheTeam";

const MAINTENANCE_MODE = false;

const App = () => {
  return (
    <Router>
      <Header />
      {MAINTENANCE_MODE ? (
        <MaintenancePage />
      ) : (
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/utsc" element={<CourseList />} />
          <Route path="/utsg" element={<CourseListUTSG />} />
          <Route path="/utm" element={<CourseListUTM />} />
          <Route path="/courses/:courseId" element={<CoursePage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/site-guidelines" element={<SiteGuidelines />} />
          <Route path="/AboutUs" element={<AboutUs />} />
          <Route path="/MeetTheTeam" element={<MeetTheTeam />} />
        </Routes>
      )}
      <Footer />
    </Router>
  );
};

export default App;
